{
  "float64": {
    "float64": 1,
    "float32": 1,
    "float16": 1,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "float32": {
    "float64": 1,
    "float32": 1,
    "float16": 1,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "float16": {
    "float64": 1,
    "float32": 1,
    "float16": 1,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 1,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "int64": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 1,
    "int32": 1,
    "int16": 1,
    "int8": 1,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 0,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "int32": {
    "float64": 1,
    "float32": 0,
    "float16": 0,
    "int64": 1,
    "int32": 1,
    "int16": 1,
    "int8": 1,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "int16": {
    "float64": 1,
    "float32": 1,
    "float16": 0,
    "int64": 1,
    "int32": 1,
    "int16": 1,
    "int8": 1,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "int8": {
    "float64": 1,
    "float32": 1,
    "float16": 1,
    "int64": 1,
    "int32": 1,
    "int16": 1,
    "int8": 1,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "uint64": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 1,
    "uint32": 1,
    "uint16": 1,
    "uint8": 1,
    "uint8c": 1,
    "complex128": 1,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "uint32": {
    "float64": 1,
    "float32": 0,
    "float16": 0,
    "int64": 1,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 1,
    "uint32": 1,
    "uint16": 1,
    "uint8": 1,
    "uint8c": 1,
    "complex128": 1,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "uint16": {
    "float64": 1,
    "float32": 1,
    "float16": 0,
    "int64": 1,
    "int32": 1,
    "int16": 0,
    "int8": 0,
    "uint64": 1,
    "uint32": 1,
    "uint16": 1,
    "uint8": 1,
    "uint8c": 1,
    "complex128": 1,
    "complex64": 1,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "uint8": {
    "float64": 1,
    "float32": 1,
    "float16": 1,
    "int64": 1,
    "int32": 1,
    "int16": 1,
    "int8": 0,
    "uint64": 1,
    "uint32": 1,
    "uint16": 1,
    "uint8": 1,
    "uint8c": 1,
    "complex128": 1,
    "complex64": 1,
    "complex32": 1,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "uint8c": {
    "float64": 1,
    "float32": 1,
    "float16": 1,
    "int64": 1,
    "int32": 1,
    "int16": 1,
    "int8": 0,
    "uint64": 1,
    "uint32": 1,
    "uint16": 1,
    "uint8": 1,
    "uint8c": 1,
    "complex128": 1,
    "complex64": 1,
    "complex32": 1,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "complex128": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 1,
    "binary": 0,
    "generic": 0,
    "bool": 0
  },
  "complex64": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 1,
    "binary": 0,
    "generic": 0,
    "bool": 0
  },
  "complex32": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 1,
    "complex64": 1,
    "complex32": 1,
    "binary": 0,
    "generic": 0,
    "bool": 0
  },
  "generic": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 0,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 0
  },
  "binary": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 0,
    "complex64": 0,
    "complex32": 0,
    "binary": 1,
    "generic": 0,
    "bool": 0
  },
  "bool": {
    "float64": 0,
    "float32": 0,
    "float16": 0,
    "int64": 0,
    "int32": 0,
    "int16": 0,
    "int8": 0,
    "uint64": 0,
    "uint32": 0,
    "uint16": 0,
    "uint8": 0,
    "uint8c": 0,
    "complex128": 0,
    "complex64": 0,
    "complex32": 0,
    "binary": 0,
    "generic": 1,
    "bool": 1
  }
}
